import React from 'react';
import { LLink, useLang } from '../i18n';
import { contact, footer, nav, ui } from '../content/site';
import Wordmark from './Wordmark';
import { Arrow, Reveal } from './motion';

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 md:mt-32">
      <section className="page">
        <Reveal className="rounded-4xl bg-cream-soft px-6 py-14 text-center md:px-12 md:py-20">
          <h2 className="t-h1 mx-auto max-w-2xl">{t(footer.ctaTitle)}</h2>
          <p className="t-lead mx-auto mt-4 max-w-xl">{t(footer.ctaBody)}</p>
          <LLink to="/contact" className="btn-primary mt-8">
            {t(ui.bookCall)}
            <Arrow />
          </LLink>
        </Reveal>
      </section>

      <div className="page mt-16 grid gap-10 border-t border-line pb-10 pt-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <Wordmark />
          <p className="mt-4 max-w-xs text-sm text-muted">{t(footer.based)}</p>
        </div>

        <nav className="md:col-span-2" aria-label={t(footer.explore)}>
          <h3 className="text-sm font-semibold">{t(footer.explore)}</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-muted">
            {[...nav, { to: '/contact', label: ui.bookCall }].map((item) => (
              <li key={item.to}>
                <LLink to={item.to} className="hover:text-ink">
                  {t(item.label)}
                </LLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-4">
          <h3 className="text-sm font-semibold">{t(footer.talk)}</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-muted">
            <li>
              {t(footer.general)}:{' '}
              <a href={`mailto:${contact.email}`} className="text-ink hover:underline">
                {contact.email}
              </a>
            </li>
            <li>
              {t(footer.support)}:{' '}
              <a href={`mailto:${contact.supportEmail}`} className="text-ink hover:underline">
                {contact.supportEmail}
              </a>
            </li>
            <li>
              <a href={contact.phoneHref} className="text-ink hover:underline" dir="ltr">
                {contact.phone}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h3 className="text-sm font-semibold">{t(footer.follow)}</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-muted">
            <li><a href={contact.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-ink">Instagram</a></li>
            <li><a href={contact.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-ink">Facebook</a></li>
            <li><a href={contact.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-ink">WhatsApp</a></li>
          </ul>
        </div>
      </div>

      <div className="page flex flex-col gap-3 border-t border-line py-6 text-xs text-muted sm:flex-row sm:items-center sm:justify-between">
        <p>
          © {year} ShopFlex Studios. {t(footer.rights)}
        </p>
        <div className="flex gap-5">
          <LLink to="/privacy-policy" className="hover:text-ink">{t(footer.privacy)}</LLink>
          <LLink to="/terms-of-service" className="hover:text-ink">{t(footer.terms)}</LLink>
        </div>
      </div>
    </footer>
  );
}
